import React, { useEffect, useState } from 'react'
import CustomInput from '../../../components/customInput/customInput';
import PrimaryButton from '../../../components/primaryButton/primarybutton';
import axiosInstance from '../../../services/api';
import { Box, Flex, Text, useToast } from '@chakra-ui/react';
import { HiUpload } from 'react-icons/hi';
import ImageUploaderx from '../../../components/imageUploader/imageUploaderx';
import CustomSelect from '../../../components/customSelect/customSelect';
import { useNavigate } from 'react-router-dom';


const CreateReport = ({loading, setLoading, setTriggerClose, source, setRefetch}) => {
  const [iid, setIid] = useState("");
  const [date, setDate] = useState("");
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [uploadedURLs, setUploadURLs] = useState([]);
  const [loadingu, setLoadingu] = useState(false);
  

  const handleImagesUpload = (images) => {
    setUploadURLs(images);
  };

  const toast = useToast();
  const navigate = useNavigate();

  const [stores, setStores] = useState([])
  const [loadingv, setLoadingv] = useState(false)

  const getInitiativeStores = async() => {
      setLoadingv(true)
      try {
          const { data } = await axiosInstance.get('/initiative-stores/assigned')
          setStores(data?.data)
      } catch(error) {
          console.error(error?.response?.data?.message)
      } finally {
          setLoadingv(false)
      }
  }

  useEffect(() => {
      getInitiativeStores()
  }, [])

  const createReport = async(e) => {
    e.preventDefault()
    setLoading(true)
    const datax = {
      initiativeId: iid,
      name,
      date,
      comment,
      uploadURLs: uploadedURLs?.map(i => i?.secure_url),
    }
    try {
      const {data} = await axiosInstance.post('/reports', datax)
      toast({
        description: data?.message,
        status: "success",
      });
      setTriggerClose('close')
      setRefetch(Math.random());
    } catch(error) {
      toast({
        title: "An Error Occurred",
        description: error?.response?.data?.message,
        status: "error",
      });
    } finally {
      setLoading(false)
    }
  }

  const assignedStores = stores?.map(i => ({
    title: i?.initiative?.name,
    value: i?.initiative?._id
  }))

  const uniqueInitiativesList = assignedStores?.filter((item, index, array) => {
    return (
      index === array.findIndex(obj => obj.title === item.title && obj.value === item.value)
    );
  });


  return (
    <form onSubmit={createReport}>
        {source === 'general' &&
        <CustomSelect
        required
        options={uniqueInitiativesList}
        placeholder={"Initiative store"}
        onChange={e => setIid(e.target.value)}
        mb={".8rem"}
        />}
        <CustomInput
        type={"text"}
        required
        placeholder={"Report title"}
        mb={".8rem"}
        onChange={e => setName(e.target.value)}
        />
        <CustomInput
        type={"date"}
        required
        placeholder={"Date"}
        mb={".8rem"}
        onChange={e => setDate(e.target.value)}
        />
         <CustomInput
        type={"text"}
        required
        placeholder={"Comment"}
        mb={".8rem"}
        onChange={e => setComment(e.target.value)}
        />
        <Box mb=".8rem">
          <ImageUploaderx
            onImagesUpload={handleImagesUpload}
            setLoading={setLoadingu}
            loading={loadingu}
            max={1}
          />
          {uploadedURLs?.map(({original_filename, url}, index) => (
            <Flex mt=".7rem" gap=".3rem" alignItems={"center"}>
              <HiUpload opacity={".6"} />
              <Text color="#7F56D9" fontWeight={"500"} fontSize={".8rem"}>{original_filename}</Text>
            </Flex>
          ))}
        </Box>
        <PrimaryButton mt="1rem" type="submit" text="Add report" icon="add" func={() => {}} loading={loading} />
    </form>
  )
}

export default CreateReport;